import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}
var providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];
var bootstrap = function () {
    return __NgCli_bootstrap_2.platformBrowser(providers).bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory);
};
var ɵ0 = bootstrap;
if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap);
    }
    else {
        console.error('HMR is not enabled for webpack-dev-server!');
        console.log('Are you using the --hmr flag for ng serve?');
    }
}
else {
    bootstrap();
}
export { ɵ0 };
// export function getBaseUrl() {
//   return document.getElementsByTagName('base')[0].href;
// }
// const providers = [
//   { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
// ];
// if (environment.production) {
//   enableProdMode();
// }
// platformBrowserDynamic(providers).bootstrapModule(AppModule)
//   .catch(err => console.log(err));
